import { render } from "./HeroAlt.vue?vue&type=template&id=3f434607"
import script from "./HeroAlt.vue?vue&type=script&lang=js"
export * from "./HeroAlt.vue?vue&type=script&lang=js"

import "./HeroAlt.vue?vue&type=style&index=0&id=3f434607&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__